import _ from "lodash";
import { handleBridgeData, delay } from "@/utils/common";
import cookie from 'js-cookie'
import Env from './env';

class Store {
  constructor(bridge) {
    this.bridge = bridge;
  }

  async init() {
    // const {
    //   uuid, starId, pageId, lob, uid,
    // } = getQueryValues(
    //   ['uuid', 'starId', 'pageId', 'lob', 'uid'],
    //   0,
    // );
    // let os = '';
    // if (Env.isIpad) {
    //   os = 'ipad';
    // } else if (Env.isIOS) {
    //   os = 'iphone';
    // } else if (Env.isAndroid) {
    //   os = 'android';
    // }
    // this.basicData = {
    //   trackId: uuid || guid(),
    //   starId: Number(starId),
    //   pageId: Number(pageId),
    //   lob: lob || '',
    //   os,
    //   d: uid,
    // };
    this.basicData = null;
    this.deviceInfo = null;
    if (this.bridge && Env.isMgtvApp) {
      try {
        await Promise.race([delay(800), this.getInfoFromBridge(this.bridge)]);
      } catch (error) {
        console.log(error);
      }
    } else {
      const uuid = cookie.get("uuid");
      const hdcn = cookie.get("HDCN");
      let ticket = null;
      if (hdcn) {
        [ticket] = hdcn.split("-");
      }
      this.deviceInfo = { uuid, ticket };
    }
  }

  getBasicInfo() {
    return { ...this.basicData };
  }

  getInfo() {
    const { deviceInfo, basicData } = this;
    return { ...basicData, ...deviceInfo };
  }

  async getInfoFromBridge(bridge) {
    const [deviceInfo, userInfo] = await Promise.all([
      this.getDeviceInfo(bridge),
      this.getUserInfo(bridge)
    ]);
    this.deviceInfo = { ...deviceInfo, ...userInfo };
  }

  getDeviceInfo(bridge) {
    return new Promise(resolve => {
      bridge.runTask(api => {
        api.callhandler("getDeviceInfo", null, data => {
          const resp = handleBridgeData(data);
          if (resp) {
            // 终端js桥和广告js桥数据结构不一样
            const source = resp.code ? handleBridgeData(resp.data) : resp;
            const dInfo = _.pick(source, [
              "idfa",
              "mod",
              "mac",
              "oaid",
              "did",
              "mf"
            ]);
            console.log(resp);
            resolve(dInfo);
          } else {
            resolve(null);
          }
        });
      });
    });
  }

  getUserInfo(bridge) {
    return new Promise(resolve => {
      bridge.runTask(api => {
        api.callhandler("getUserInfo", null, data => {
          const resp = handleBridgeData(data);
          if (resp) {
            // 终端js桥和广告js桥数据结构不一样
            const source = resp.code ? handleBridgeData(resp.data) : resp;
            const uInfo = _.pick(source, ["uuid"]);
            resolve(uInfo);
          } else {
            resolve(null);
          }
        });
      });
    });
  }
}

export default Store;
